/** In-place explanation for surfaces that only show [code]smith. */
export function CodesmithDisabledNotice() {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-2 p-6 text-center type-body-s-regular text-neutral-500 dark:text-neutral-400">
      [code]smith is not enabled for this organization.
    </div>
  );
}
